export default function test(str) {
    //if (!str) return false;
    if (str === "") return true;
    // regexp based check, allow only digits
    return /^[a-z_]{4,64}$/.test(str);
}
